import script from "./setup-fee-grid.vue?vue&type=script&setup=true&lang=ts"
export * from "./setup-fee-grid.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__